import { twMerge } from 'tailwind-merge';
import { CustomImage, Title, Button, Note } from '../atoms';

export interface IResourceNotFoundScreen {
  emoji?: string;
  title: string;
  description: string;
  buttonText?: React.ReactNode | string;
  href?: string;
  onClick?: VoidFunction;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  showImage?: boolean;
  imageType?: 'empty' | '404' | '500';
}

export function ResourceNotFoundScreen({
  emoji = '🔍',
  title,
  description,
  buttonText,
  href,
  onClick,
  className,
  titleClassName,
  descriptionClassName,
  showImage = false,
  imageType = 'empty',
}: IResourceNotFoundScreen) {
  return (
    <div
      className={twMerge(
        'flex h-full w-full items-center justify-center bg-white px-6 py-8',
        className,
      )}>
      <div className="flex flex-col items-center text-center">
        {showImage ? (
          <CustomImage type={imageType} className="mb-6 h-24 w-24" />
        ) : (
          <div className="mb-4 text-5xl" style={{ lineHeight: '60px' }}>
            {emoji}
          </div>
        )}

        <Title type="m" className={twMerge('mb-2 font-semibold text-gray-800', titleClassName)}>
          {title}
        </Title>

        <Note className={twMerge('text-gray-500 leading-6', descriptionClassName)} type="m">
          {description}
        </Note>

        {(buttonText || href) && (
          <div className="mt-6">
            <Button type="primary" href={href} onClick={onClick}>
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
